var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCensorship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.533 47.2512L40.1673 47.04L36.4173 49.2051L38.658 50.4987C39.0881 50.7472 39.593 50.812 40.0796 50.6817C40.5663 50.5514 40.9709 50.2426 41.2193 49.8125C41.4675 49.3824 41.5326 48.8775 41.4023 48.3909C41.2719 47.9042 40.9631 47.4996 40.533 47.2512ZM39.5923 39.0004C39.2744 39.0004 38.9525 39.0811 38.6579 39.2512L24.8014 47.2512C23.906 47.7682 23.5981 48.9171 24.1151 49.8126C24.6321 50.708 25.7814 51.0159 26.6764 50.4989L40.5329 42.4987C41.4281 41.9817 41.736 40.8329 41.2191 39.9375C40.8724 39.3366 40.2408 39.0004 39.5923 39.0004ZM24.8015 42.4987L25.1673 42.71L28.9173 40.5449L26.6765 39.2512C25.7815 38.7344 24.6323 39.0422 24.1153 39.9375C23.5984 40.8329 23.9063 41.9817 24.8015 42.4987Z",
    fill: "url(#paint0_linear_1825_191765)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.667 0C15.0221 0 0.666992 14.3551 0.666992 32C0.666992 49.6449 15.0221 64 32.667 64C50.3119 64 64.667 49.6449 64.667 32C64.667 14.3551 50.3119 0 32.667 0ZM15.6509 24.5C15.6509 20.9504 18.5387 18.0625 22.0884 18.0625C25.638 18.0625 28.5259 20.9504 28.5259 24.5C28.5259 28.0496 25.638 30.9375 22.0884 30.9375C18.5387 30.9375 15.6509 28.0496 15.6509 24.5ZM44.4667 51.6874C43.7174 52.9852 42.504 53.9144 41.0499 54.304C40.57 54.4331 40.0753 54.4988 39.5784 54.4992C38.6049 54.4992 37.6456 54.2447 36.7827 53.7465L32.667 51.3703L28.5512 53.7465C27.6884 54.2446 26.7291 54.4991 25.7556 54.4991C25.2587 54.4987 24.764 54.4331 24.2841 54.3039C22.83 53.9142 21.6166 52.985 20.8675 51.6874C20.1184 50.3897 19.9202 48.8742 20.3099 47.4201C20.5727 46.439 21.0821 45.5681 21.7839 44.8749C20.0099 43.1201 19.5629 40.3223 20.8675 38.0624C22.4184 35.3765 25.8651 34.4526 28.5514 36.0035L32.667 38.3799L36.7826 36.0036C39.4687 34.4526 42.9155 35.3763 44.4665 38.0625C45.7711 40.3224 45.3241 43.1203 43.5501 44.875C45.3241 46.6295 45.7712 49.4275 44.4667 51.6874ZM43.2457 30.9375C39.6961 30.9375 36.8082 28.0496 36.8082 24.5C36.8082 20.9504 39.6961 18.0625 43.2457 18.0625C46.7954 18.0625 49.6832 20.9504 49.6832 24.5C49.6832 28.0496 46.7954 30.9375 43.2457 30.9375Z",
    fill: "url(#paint1_linear_1825_191765)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0879 27.1875C23.5722 27.1875 24.7754 25.9843 24.7754 24.5C24.7754 23.0157 23.5722 21.8125 22.0879 21.8125C20.6036 21.8125 19.4004 23.0157 19.4004 24.5C19.4004 25.9843 20.6036 27.1875 22.0879 27.1875Z",
    fill: "url(#paint2_linear_1825_191765)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2461 27.1875C44.7304 27.1875 45.9336 25.9843 45.9336 24.5C45.9336 23.0157 44.7304 21.8125 43.2461 21.8125C41.7618 21.8125 40.5586 23.0157 40.5586 24.5C40.5586 25.9843 41.7618 27.1875 43.2461 27.1875Z",
    fill: "url(#paint3_linear_1825_191765)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1825_191765",
    x1: 23.8643,
    y1: 44.8751,
    x2: 41.4699,
    y2: 44.8751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1825_191765",
    x1: 0.666992,
    y1: 32,
    x2: 64.667,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1825_191765",
    x1: 19.4004,
    y1: 24.5,
    x2: 24.7754,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1825_191765",
    x1: 40.5586,
    y1: 24.5,
    x2: 45.9336,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensorship);
export default __webpack_public_path__ + "static/media/censorship.935377a7beda693d6112bbb3c0489288.svg";
export { ForwardRef as ReactComponent };